
















import { Component, Prop, Emit, Vue } from "vue-property-decorator";
@Component
export default class InputTextComponent extends Vue {
  @Prop()
  public inputId!: string;

  @Prop({
    default: "38px"
  })
  public height!: string;

  @Prop({
    default: "100%"
  })
  public width!: string;

  @Prop({
    default: ""
  })
  pattern!: string;

  @Prop({
    default: ""
  })
  placeholder!: string;

  @Prop({
    default: false
  })
  isDisabled!: boolean;

  @Prop({
    default: false
  })
  hasError!: boolean;

  @Prop({
    default: ""
  })
  value!: string;

  @Prop()
  maxLength?: number;

  @Emit()
  change(value: string): string {
    return value;
  }

  @Emit()
  onKeydownEnter(event: KeyboardEvent) {
    const inputEvent = event.target as HTMLInputElement;
    return inputEvent.value;
  }

  get internalValue(): string {
    return this.value;
  }

  set internalValue(value: string) {
    this.change(value);
  }
}
